import { DataSource } from '@angular/cdk/collections';
import { GetClient } from '../generated-client/generated-client';
import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { PaginationBaseService } from 'ng-lightquery';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ClientsOfCustomerService extends PaginationBaseService<GetClient> implements DataSource<GetClient> {
  protected http: HttpClient;

  constructor() {
    const http = inject(HttpClient);

    super(http);
    this.http = http;

    this.baseUrl = '/api/clients/paginated';
    this.sort = { propertyName: 'name', isDescending: true };
  }

  connect(): Observable<GetClient[]> {
    return this.paginationResult.pipe(map(r => r.data));
  }

  disconnect() {}
}
